module.exports = __webpack_public_path__ + "img/dashboard_invoices.39912b0.png";